import React from "react";
import { useLocation } from "react-router";
import { Link } from "react-router-dom";
import { Row, Col } from "reactstrap";

interface BreadcrumbProps {
  breadcrumbItem: string;
  title: string;
  titleLink?: string;
  showLeftTitle?: boolean;
}



const Breadcrumb = ({ breadcrumbItem, title, titleLink, showLeftTitle = true, }: BreadcrumbProps) => {
  const location = useLocation();
 
  const showBackIcon = titleLink && titleLink !== location.pathname;
  return (
    <Row>
      <Col xs="12">
        <div className="page-title-box d-flex align-items-center justify-content-between mt-md-0">
          <div className="page-title-left">
            {showLeftTitle && (
              <h4 className="mb-sm-0">
                {showBackIcon && (
                  <Link to={titleLink}>
                    <img
                      className="back-icon"
                      src="/assets/icons/dropdown.svg"
                      alt="Back"
                      style={{
                        width: "16px",
                        height: "16px",
                        marginRight: "6px",
                        verticalAlign: "middle",
                        transform: "rotate(90deg) scale(1.5)",
                      }}
                    />
                  </Link>
                )}
                {breadcrumbItem}
              </h4>
            )}
          </div>
          <div className="page-title-right">
            <ol className="breadcrumb m-0">
              <li className="breadcrumb-item">
                {titleLink ? <Link to={titleLink}>{title}</Link> : title}
              </li>
              <li className="breadcrumb-item active">{breadcrumbItem}</li>
            </ol>
          </div>
        </div>
      </Col>
    </Row>
  );
};

export default Breadcrumb;
